import { cn } from "@/lib/utils";

// Official Grabarte isotype (A inside equilateral triangle) from the brandbook.
export function GrabarteMark({ className, variant = "dark" }) {
  const src = variant === "light" ? "/brand/grabarte-isotype-white.png" : "/brand/grabarte-isotype-navy.png";
  return <img src={src} alt="Grabarte" className={cn("select-none object-contain", className)} draggable={false} />;
}

export default function Logo({ variant = "light", className }) {
  // variant "light" = for dark backgrounds (white wordmark), "dark" = for light backgrounds (navy wordmark)
  const src = variant === "light" ? "/brand/grabarte-wordmark-white.png" : "/brand/grabarte-wordmark-navy.png";
  return <img src={src} alt="Grabarte" className={cn("h-[22px] w-auto select-none object-contain", className)} draggable={false} />;
}
